<app-table [data]="toolReturns"
           [config]="tableConfig"
           [isLoading]="isLoading"
           [rowExpand]="false"
           [saveFilters]="true"
           [hasTitle]="hasTitle"
           [isMaterial]="isMaterial"
           [headerBackgroundColor]="headerBackgroundColor"
           [title]="'atom.tool-returns.table.title-lines' | translate"
           (sortChange)="onSortChange($event)"
           (filterChange)="onFilterChange($event)"
           (pageChange)="onPageChange($event)">
    <app-table-column [header]="'atom.tool-returns.table.columns.createdDate' | translate"
                      [sortable]="false"
                      field="createdDate">
    </app-table-column>
    <app-table-column [header]="'atom.tool-returns.table.columns.toolRequest' | translate"
                      [filterPlaceholder]="'atom.tool-returns.table.filter.toolRequest' | translate"
                      [filter]="true"
                      [sortable]="false"
                      field="toolRequestName">
        <ng-template #body
                     let-toolReturn="rowData">
            <span>{{ toolReturn.toolRequest.name }}</span>
        </ng-template>
    </app-table-column>
    <app-table-column [header]="'atom.tool-returns.table.columns.line' | translate"
                      [filterPlaceholder]="'atom.tool-returns.table.filter.line' | translate"
                      [filter]="true"
                      [sortable]="false"
                      field="line">
        <ng-template #body
                     let-toolReturn="rowData">
            <span>{{ toolReturn.line.name }}</span>
        </ng-template>
    </app-table-column>
    <app-table-column [header]="'atom.tool-returns.table.columns.createdBy' | translate"
                      [filterPlaceholder]="'atom.tool-returns.table.filter.createdBy' | translate"
                      [filter]="true"
                      [sortable]="false"
                      field="createdBy">
        <ng-template #body
                     let-toolReturn="rowData">
            <span>{{ toolReturn.createdBy.fullName }}</span>
        </ng-template>
    </app-table-column>
    <app-table-column [header]="'atom.tool-returns.table.columns.status' | translate"
                      [sortable]="false"
                      field="status">
        <ng-template #filter
                     let-column="column"
                     let-table="table">
            <app-dropdown [(ngModel)]="column.filterValue"
                          [items]="statusFilters"
                          valueField="value"
                          emptyText="{{'atom.tool-returns.table.filter.status' | translate}}"
                          (selectItem)="table.onFilterChange(column)"></app-dropdown>
        </ng-template>
        <ng-template #body
                     let-tool="rowData">
            <span>{{ tool.status | translate }}</span>
        </ng-template>
    </app-table-column>
    <app-table-column cls="last-column"
                      [header]="'atom.tool-returns.table.columns.action' | translate"
                      field="action">
        <ng-template #body
                     let-toolReturn="rowData">
            <app-button *ngIf="isDelivered(toolReturn)"
                        type="primary"
                        class="process-button"
                        (clicked)="onActionClick(toolReturn, true)">{{ 'generic.buttons.process' | translate }}
            </app-button>
            <app-button *ngIf="isWaitingForApproval(toolReturn)"
                        type="warning"
                        class="process-button"
                        (click)="onActionClick(toolReturn, false)">{{ 'generic.buttons.resume' | translate }}
            </app-button>
            <app-tooltip *ngIf="toolReturn.hasPriority" type="info"
                         record="{{'atom.tool-returns.table.columns.orderedPriority' | translate}}">
            </app-tooltip>
        </ng-template>
    </app-table-column>
</app-table>
